import React from "react";
import { Send } from "lucide-react";
import ComingSoon from "./ComingSoon";

export default function AdminBroadcasts() {
    return (
        <ComingSoon
            title="Email Broadcasts"
            eyebrow="Communications"
            description="Send announcements, course-launch emails or re-engagement campaigns to segments of your audience."
            icon={Send}
            ctaLabel="+ New Broadcast"
            accent="grape"
            columns={["Subject", "Segment", "Sent to", "Open rate", "Sent at", "Status"]}
            mockRows={[
                ["Spring 2026 — New HEAT Programme is live", "All students", "8,124", "42.6%", "12 Feb 2026", "Sent"],
                ["Re-engage: 30% off Cybersecurity bundle", "Inactive 30+ days", "1,402", "—", "Scheduled 22 Feb", "Scheduled"],
                ["Q4 BMG Threat Briefing", "Corporate clients", "94", "68.1%", "30 Jan 2026", "Sent"],
                ["Welcome — your first lesson", "New signups", "Auto", "73.2%", "Always-on", "Active"],
            ]}
        />
    );
}
